import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { selectUserRole } from '../features/auth/selectors'
import { selectExam } from '../features/exams/selectors'
import { getUserDashboard } from '../libs/auth'
import { ExamStatus } from '../model/exam'
import { readTeloParams } from '../routing/readTeloParams'
import { useTeloSelector } from '../store'

const mapPathsToStatus: { [k: string]: ExamStatus[] } = {
	'/store/:storeId/pretest/:examId': [
		'IntakeFormEnded',
		'PreTestStarted',
		'Paused',
	],
	'/exam-attribution/:examId': [
		'IntakeFormEnded', // TEL-1956
		'PreTestStarted',
		'PreTestFinished',
		'Paused',
		'LensTrialQuit',
		'DoctorEndedWithLensTrial',
		'RefractionistStarted',
		'RefractionistEnded',
	],
	'/refractionist/call/:examId': ['RefractionistStarted'],
	'/refractionist/exam/:examId': ['RefractionistStarted'],
	'/doctor/call/:examId': [
		'RefractionistEnded',
		'DoctorModeSelected',
		'DoctorStarted',
		'Paused',
	],
	'/doctor/exam/:examId': [
		'RefractionistEnded',
		'DoctorModeSelected',
		'DoctorStarted',
		'Paused',
		// Added this state for tel-2287
		'Uncompleted',
		// Added this two states for tel-1844
		'Interrupted',
		'Waiting',
		// Adding ending states so to support 1681
		'Ended',
		'DoctorEndedWithLensTrial',
		'LensTrialQuit',
		'DoctorEnded',
	],
}

const CheckExamStatusAndPathMatch: React.FC<{ paths: string[] }> = ({
	paths,
}) => {
	const { examId, storeId } = readTeloParams(
		{ name: 'examId', required: false },
		{ name: 'storeId', required: false },
	)
	const userRole = useTeloSelector(selectUserRole)
	const exam = useTeloSelector(selectExam(examId || ''))
	const { state }: { state: { fromDoctorSelectionPage?: boolean } } =
		useLocation()
	const fromDoctorSelect = (state && state.fromDoctorSelectionPage) || false
	const isExamPageCoherentWithExamStatus =
		!exam ||
		(exam &&
			paths.every(
				path =>
					!mapPathsToStatus[path] ||
					!mapPathsToStatus[path].length ||
					mapPathsToStatus[path].includes(exam.status),
			))
	const isExamRefractionistInterrupted =
		!!exam &&
		exam?.history[exam?.history.length - 1] &&
		exam?.history[exam?.history.length - 1].currentStatus === 'Interrupted' &&
		exam?.history[exam?.history.length - 1].prevStatus ===
			'RefractionistStarted' &&
		paths.every(path =>
			['/refractionist/call/:examId', '/refractionist/exam/:examId'].includes(
				path,
			),
		)
	if (
		!isExamPageCoherentWithExamStatus &&
		!isExamRefractionistInterrupted &&
		!fromDoctorSelect
	) {
		return <Navigate to={getUserDashboard(userRole, storeId!)} />
	} else {
		return null
	}
}

export default CheckExamStatusAndPathMatch
